<template>
  <el-container>
    <el-main>{{ $t("Page visible par tout le monde") }}</el-main>
  </el-container>
</template>

<script>
export default {
  metaInfo () {
    return {
      title: this.$t('À propos')
    }
  }
}
</script>
